import { useContext } from 'react';
import { MainContext } from 'context';
import { emitters } from 'config';
import { styled } from 'themes';

const Container = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',

  '@media (max-width: 1280px)': {
    flexDirection: 'column',
    marginLeft: 0,
  },

  '@media (max-width: 768px)': {
    marginY: 32,
    width: '100%',
    marginX: 0,
  },
});

const Link = styled('a', {
  textAlign: 'left',
  textDecoration: 'none',
  marginLeft: 20,

  '&:first-child': {
    marginLeft: 0,
  },

  '@media (max-width: 1280px)': {
    marginLeft: 0,
    marginBottom: 20,

    '&:last-child': {
      marginBottom: 0,
    },
  },
});

const ImageButtonsStore = styled('img', {
  height: 53,
  display: 'block',

  '&:hover': {
    color: '$hoverDark',
  },

  '@media (max-width: 768px)': {
    width: '100%',
    height: 'auto',
  },
});

export default function ButtonStore(): JSX.Element {
  const { state } = useContext(MainContext);
  const portalData = state.portal
    ? emitters[state.emissor].portal[state.portal]
    : false;

  if (state.portal && portalData) {
    return (
      <Container>
        {portalData.buttons?.map((button) => {
          return (
            <Link key={button.code} href={button.link} target="_blank">
              <ImageButtonsStore src={button.image} alt="Button Image" />
            </Link>
          );
        })}
      </Container>
    );
  }

  return <div />;
}
